type Falsy = undefined | null | false | 0 | '';

export default function isTruthy<T>(value: T | Falsy): value is T {
  return Boolean(value);
}
